// src/components/auth/PolicyCheckbox.tsx
import React from "react";

export default function PolicyCheckbox(props: {
  checked: boolean;
  onChange: (v: boolean) => void;
  translate: (k: string) => string;
  disabled?: boolean;
}) {
  const { checked, onChange, translate, disabled = false } = props;

  return (
    <div className="mb-1">
      <div className="form-check">
        <input
          className="form-check-input"
          id="register-privacy-policy"
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />

        <label className="form-check-label" htmlFor="register-privacy-policy">
          {translate("I agree to")}{" "}
          <a href="https://aida-dz.xyz" target="_blank" rel="noreferrer">
            {translate("privacy policy & terms")}
          </a>
        </label>
      </div>
    </div>
  );
}
